import { cn } from '@/lib/utils'

type FieldLabelProps = {
  htmlFor: string
  /** Caption — render this component immediately before the associated control so DOM order is label → field. */
  label: string
  required?: boolean
  inverse?: boolean
  disabled?: boolean
  /** Use `FIELD_CAPTION_TEXT_CLASS[size]` from `fieldCaptionTypography`. */
  captionTextClassName: string
  className?: string
}

/**
 * Shared caption `<label>` for TextField, TextareaField, Select, etc.
 * Parent stacks this element and the control with `gap-0`. Resets Bootstrap label margin.
 */
const FieldLabel = ({
  htmlFor,
  label,
  required,
  inverse = false,
  disabled = false,
  captionTextClassName,
  className,
}: FieldLabelProps) => {
  return (
    <label
      className={cn('flex w-full flex-col gap-0 !mb-0', className)}
      htmlFor={htmlFor}
    >
      <span
        className={cn(
          'font-semibold',
          captionTextClassName,
          inverse
            ? 'text-white/70'
            : disabled
              ? 'text-text-disabled'
              : 'text-secondary'
        )}
      >
        {label}
        {!required && ' (optional)'}
      </span>
    </label>
  )
}

export { FieldLabel }
export type { FieldLabelProps }
